<template>
  <div :style="cssBarStyle"></div>
</template>

<script>
export default {
  name: "GradientBar",
  props: {
    barHeightIn: Number,
  },
  computed: {
    cssBarStyle() {
      return {
        height: this.barHeightIn + "px",
        width: "100%",
        background: "var(--linear-gradient-estado)",
      };
    },
  },
};
</script>

<style></style>
